const mobileShadows = {
  "&:before, &:after": {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    height: "40px",
    pointerEvents: "none",
    zIndex: 30,
  },

  "&:before": {
    background: "linear-gradient(rgba(255,255,255,1) 10%, rgba(255,255,255,0))",
    top: 0,
  },

  "&:after": {
    background: "linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1) 50%)",
    bottom: 0,
  },
};

export const customisations =
  ({ UIVersion }) =>
  ({ isMobile }) => ({
    background: "background",
    height: "100%",
    padding: isMobile ? (UIVersion === 2 ? "30px 0" : "40px 0") : "20px 0",
    overflow: "auto",
    ...(isMobile && UIVersion !== 2 ? mobileShadows : {}),
  });

export const formFields = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: isMobile ? "flex-start" : "center",
  alignItems: "center",
  py: "0",
  px: isMobile ? "40px" : "0",
  mx: "0",

  "> *:not(:last-child)": {
    mb: isMobile ? "20px !important" : "0",
  },
});

export const formFieldsV2 = () => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
});

export const progressContainer = {
  position: "absolute",
  bottom: "10px",
  left: 0,
  right: 0,
  zIndex: 40,
  pointerEvents: "none",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};
